var _styled;

// https://govuk-static.herokuapp.com/component-guide/lead_paragraph
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var StyledParagraph = styled('p')((_styled = {
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_18,
  lineHeight: LINE_HEIGHT.SIZE_18,
  marginTop: 0
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_24,
  lineHeight: LINE_HEIGHT.SIZE_24
}, _styled));

var LeadParagraph = function LeadParagraph(_ref) {
  var children = _ref.children;
  return React.createElement(StyledParagraph, null, children);
};

LeadParagraph.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
export default withWhiteSpace({
  marginBottom: 5
})(LeadParagraph);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/lead-paragraph/es/index.js
// module id = 125
// module chunks = 0